module.exports = "<a href=\"javascript:void(0);\" style=\"color: transparent;\" @click=\"handleChangeType\">\n  <v-card class=\"block-tenant-type mx-1 pa-3\" :class=\"containerClass\" :style=\"customStyle\">\n    <v-icon color=\"primary\" class=\"block-tenant-type__icon\">{{icon}}</v-icon>\n    <h3 class=\"headline mb-0 block-tenant-type__title primary--text\">{{title}} </h3>\n    <div v-if=\"isActive\" class=\"block-tenant-type__arrow-down\"></div>\n  </v-card>\n\n</a>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/block/components/block-tenant-types-item/template.html
// module id = IbK2
// module chunks = 0